"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prefetchFieldVisibilitySettings = exports.fetchFieldVisibilitySettings = exports.postFvs = exports.patchFvs = exports.calculateRequests = exports.convertLegacyFieldVisibilitySettings = exports.convertFieldToLegacyFormat = exports.applyFieldVisibilitySettings = void 0;
const cacheTimes_1 = require("../cacheTimes");
const errors_1 = require("../../errors/errors");
const react_query_1 = require("react-query");
const react_1 = __importDefault(require("react"));
const lodash_1 = __importDefault(require("lodash"));
function applyFieldVisibilitySettings(children, settings, fvsLevelId) {
    if (!settings) {
        return children;
    }
    else {
        const paneChildren = react_1.default.Children.toArray(children);
        const components = settings.components.filter(c => c.fvsLevelId === fvsLevelId);
        return paneChildren && components
            ? paneChildren
                .sort((a, b) => {
                if (!a || !b) {
                    return 0;
                }
                const matchingFieldA = components.find(component => component.fieldName ===
                    a.props.id);
                const matchingFieldB = components.find(component => component.fieldName ===
                    b.props.id);
                if (!matchingFieldA && !matchingFieldB) {
                    return paneChildren.indexOf(a) - paneChildren.indexOf(b);
                }
                else if (!matchingFieldA) {
                    return 1;
                }
                else if (!matchingFieldB) {
                    return -1;
                }
                else {
                    return matchingFieldA.sortOrder > matchingFieldB.sortOrder
                        ? 1
                        : matchingFieldA.sortOrder < matchingFieldB.sortOrder
                            ? -1
                            : 0;
                }
            })
                .map(child => {
                const matchingField = components.find(component => component.fieldName ===
                    child.props.id);
                const { ignoreFVS, ...otherProps } = child.props;
                return react_1.default.cloneElement(child, {
                    ...otherProps,
                    Id: matchingField ? matchingField.Id : undefined,
                    required: !ignoreFVS && matchingField
                        ? matchingField.required
                        : child.props.required,
                    hidden: !ignoreFVS && matchingField
                        ? matchingField.visible === false
                        : child.props.hidden,
                    editable: !ignoreFVS && matchingField
                        ? matchingField.editable === undefined
                            ? true
                            : matchingField.editable
                        : child.props.readOnly !==
                            true,
                    readOnly: !ignoreFVS && matchingField
                        ? matchingField.editable === undefined
                            ? false
                            : !matchingField.editable
                        : child.props.readOnly,
                    ignoreFVS: child.props.ignoreFVS,
                    sortOrder: matchingField
                        ? matchingField.visible === false
                            ? -1
                            : matchingField.sortOrder
                        : undefined
                }, child.props.children);
            })
            : null;
    }
}
exports.applyFieldVisibilitySettings = applyFieldVisibilitySettings;
exports.convertFieldToLegacyFormat = (field) => {
    return {
        Id: field.Id,
        FieldName: field.fieldName,
        Required: field.required,
        ShowOnDesktop: field.visible,
        DesktopSortOrder: field.visible ? field.sortOrder : -1,
        EditableOnDesktop: field.editable,
        ShowOnMobile: field.visible,
        MobileSortOrder: field.visible ? field.sortOrder : -1,
        EditableOnMobile: field.editable,
        SubType: field.fvsLevelId ? `${field.fvsLevelId}` : null,
        EntityType: "N/A"
    };
};
exports.convertLegacyFieldVisibilitySettings = (legacySettings) => {
    return lodash_1.default.reverse(lodash_1.default.sortBy(legacySettings, "UpdatedDateTime")).map(setting => ({
        fieldName: setting.FieldName,
        required: setting.Required,
        visible: setting.ShowOnDesktop,
        sortOrder: setting.DesktopSortOrder,
        editable: setting.EditableOnDesktop,
        Id: setting.Id,
        fvsLevelId: setting.SubType
            ? Number.parseInt(setting.SubType)
            : undefined
    }));
};
exports.calculateRequests = (newSettings, data) => {
    if (newSettings.length === 0) {
        return [null];
    }
    const settingsToUpload = newSettings;
    const requestChanged = (previousField, newField) => {
        if (previousField && newField) {
            let keys = Object.keys(newField);
            let result = false;
            keys.forEach(key => {
                result = result || previousField[key] !== newField[key];
            });
            return result;
        }
        else {
            return true;
        }
    };
    const requests = settingsToUpload.map(fieldObject => {
        if (!fieldObject)
            return null;
        const previousFieldSetting = data &&
            data.find(prev => prev.SectionName === fieldObject.SectionName &&
                prev.FieldName === fieldObject.FieldName &&
                prev.SubType === fieldObject.SubType);
        const Id = previousFieldSetting && previousFieldSetting.Id;
        if (!requestChanged(previousFieldSetting, fieldObject)) {
            return null;
        }
        else if (previousFieldSetting && Id) {
            return { data: fieldObject, id: Id };
        }
        else {
            return { data: fieldObject };
        }
    });
    return lodash_1.default.uniqWith(requests, lodash_1.default.isEqual);
};
exports.patchFvs = ({ apiClient, id, diff }) => apiClient
    .request({
    url: `FieldVisibilitySettings`,
    method: "PATCH",
    data: {
        ...diff,
        Id: id
    }
})
    .then(response => response);
exports.postFvs = ({ apiClient, data }) => apiClient
    .request({
    url: `FieldVisibilitySettings`,
    method: "POST",
    data
})
    .then(response => response);
exports.fetchFieldVisibilitySettings = args => {
    args = args || {};
    const { apiClient, containerId, app, headers, urlPrefix, id } = args;
    return new Promise((resolve, reject) => {
        if (!apiClient) {
            throw new Error("No API client was passed in to fetchFieldVisibilitySettings");
        }
        if (!containerId) {
            resolve(undefined);
        }
        else {
            apiClient
                .get(`${urlPrefix ? urlPrefix : ""}FieldVisibilitySettings${id ? `/${id}` : ""}`, {
                headers: headers || {},
                params: id
                    ? {}
                    : {
                        $top: "10000",
                        $filter: `Platform eq ${app} and SectionName eq ${containerId}`
                    }
            })
                .then(response => {
                if (response.status === 200 &&
                    response.data &&
                    response.data.d &&
                    response.data.d.results) {
                    resolve(response.data.d.results);
                }
                else {
                    throw response;
                }
            })
                .catch(error => {
                errors_1.displayAndLogErrorWithMessage(error, "CouldNotFetchFVSErrorMessage");
                reject(error);
            });
        }
    });
};
exports.prefetchFieldVisibilitySettings = (params) => {
    return new Promise((resolve, reject) => {
        const { apiClient, headers, id, ...rest } = params;
        react_query_1.queryCache
            .prefetchQuery(["fvs", { ...rest }], () => exports.fetchFieldVisibilitySettings({ ...params }), { staleTime: cacheTimes_1.CacheTimes.TwentyFourHours })
            .then(value => resolve(value))
            .catch(error => reject(error));
    });
};
//# sourceMappingURL=FieldVisibilitySettings.js.map